import { FC } from "react";
import { IconPropsType } from ".";

export const DownLoadArrow: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? "24"}
      height={props.size ?? "24"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9994 2C16.8585 2 17.5549 2.69645 17.5549 3.55556V16.3927L20.9331 13.0145C21.5406 12.4071 22.5255 12.4071 23.133 13.0145C23.7405 13.622 23.7405 14.6069 23.133 15.2144L17.0993 21.2481C16.8076 21.5398 16.4119 21.7037 15.9994 21.7037C15.5868 21.7037 15.1912 21.5398 14.8994 21.2481L8.86577 15.2144C8.25829 14.6069 8.25829 13.622 8.86577 13.0145C9.47325 12.4071 10.4582 12.4071 11.0657 13.0145L14.4438 16.3927V3.55556C14.4438 2.69645 15.1403 2 15.9994 2ZM8.41016 28.4444C8.41016 27.5853 9.1066 26.8889 9.96571 26.8889H22.0331C22.8922 26.8889 23.5886 27.5853 23.5886 28.4444C23.5886 29.3036 22.8922 30 22.0331 30H9.96571C9.1066 30 8.41016 29.3036 8.41016 28.4444Z"
        fill={props.color ?? "#555555"}
      />
    </svg>
  );
};
